import React from "react";
// import Carousel from '../carousel/carousel';

class Mantra_25_New_Canvas extends React.Component {
  render() {
    const {
      step1,
      step2,
      step3,
      step4,
      step5,
      step6,
      step7,
      step8,
      module_name,
    } = this.props;
    return (
      <section
        className="canvas_section mantra25b_prev_section setdiv_canvas"
        id={"canvas_generate_" + module_name}
      >
        <img src="/assets/img/Mantra_25b.jpg" className="m3a1_img" />
        <span className="m25b_txt1">{step1} </span>
        <span className="m25b_txt2">{step2} </span>
        <span className="m25b_txt3">{step3} </span>
        <span className="m25b_txt4">{step4} </span>
        <span className="m25b_txt5">{step5} </span>
        <span className="m25b_txt6">{step6} </span>
        <span className="m25b_txt7">{step7} </span>
        <span className="m25b_txt8">{step8} </span>
      </section>
    );
  }
}

export default Mantra_25_New_Canvas;
